import { http } from 'cdui-js';

// 问卷列表
export const fetchQuestionnaire = async () => {
  const res = (await http.get(`/user/riskAssessment/questionnaire`)) as any;
  const data = res?.questions?.map((r) => ({
    id: r.id,
    title: r.title,
    type: 'radio',
    options: r.options.map((cr) => ({ label: cr.label, value: cr.id })),
  }));

  // id: 'q1',
  //   title: '1、您的年龄介乎于哪个组别?',
  //   type: 'checkbox',
  //   required: true,
  //   options: [
  //     { value: 'a', label: 'a. 18-35' },
  //     { value: 'b', label: 'b. 36-50' },
  //     { value: 'c', label: 'c. 51-65' },
  //     { value: 'd', label: 'd. >65' },
  //   ],

  return data;
};

// 提交问卷 /user/riskAssessment/submit
export const submitRiskAssess = async (answers) => {
  await http.post(`/user/riskAssessment/submit`, {
    answers,
  });
};

// 测评结果
export const fetchRiskAssessLatest = async () => {
  const res = await http.get(`/user/riskAssessment/latest`);

  return res;
};

/** 标准风险测评最新结果。加开加密货币账户要求 levelCode 为 AGGRESSIVE */
export const fetchVirtualAssetRiskLatest = async () => {
  const res = (await http.get(
    `/user/riskAssessment/latest?assessmentType=STANDARD`,
  )) as { levelCode?: string | null; data?: { levelCode?: string | null } } | null;
  return (res?.data ?? res ?? {}) as { levelCode?: string | null };
};

export const fetchTrustDeviceList = async () => {
  const res = (await http.get(`/user/tbAdminTrustDevice/myTrustDeviceList`)) as any;

  return {
    total: res.total,
    list: res.list.map((i) => ({
      model: i.deviceCode,
      lastLogin: i.lastLoginTime + ' ' + i.ip,
      os: i.deviceName,
    })),
  };
};

// 登录历史
export const fetchLoginHistory = async (deviceCode) => {
  const res = (await http.get(`/user/login/loginHistory?deviceCode=${deviceCode}`)) as any;

  return res.map((i) => ({
    id: i.id,
    time: i.createTime,
    ip: i.ip,
  }));
};
//

//资金流水
export const fetchFundFlow = async (params) => {
  const res = await http.get(`/2go/fund/fundFlow`, params) as any;
  return res;
};
